import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody
} from "reactstrap";
import { withRouter } from "../../utils/router-compat";
import "./HoDashboard.css";
import LocationWiseFilter from "../../components/LocationWiseFilter/LocationWiseFilter";
import YTDFilter from "../../components/YTDFilter/YTDFilter";
import HODashboardService from "../../services/HODashaboardService";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import { formatNumber, downlodFile } from "../../utils/utils";
import Storage from "../../services/Storage";
import AutoSuggestionDealer from "../../components/AutoSuggestionDealer/AutoSuggestionDealer";
import FleetManagerService from "../../services/FleetManagerService";
import _ from "lodash";
import DashboardService from "../../services/DashboardService";
import { askForPermissioToReceiveNotifications } from "../../push-notification.js";
import Moment from "react-moment";
import { Roles } from "../../constants/constant.role";
import SpeacialEngagementService from "../../services/SpecialEngagementService";
import SpeacialEngagement from "../../modal/SpeacialEngagement/SpeacialEngagement";

class HoDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetail: Storage.getUserDetail(),
      memberRole: Storage.getUserDetail().type,
      isSpecialEngagementModalOpen: false,
      tableData: [],
      DirectIndirecttableData: [],
      total_tyres: 0,
      DirectIndirect_total_tyres: 0,
      type: false,
      fmOfftakeEntriesCount: {},
      fleetStatusCountData: [],
      fleetStatusCountData_total_tyres: null,
      sales_achievement: {
        tbr: {
          direct_achievement: 0,
          direct_sales: 0,
          percent_direct_sales: 0,
          indirect_achievement: 0,
          indirect_sales: 0,
          percent_indirect_sales: 0,
          total_sales: 0,
          total_achievement: 0,
          percent_total_sales: 0
        },
        tbb: {
          direct_achievement: 0,
          direct_sales: 0,
          percent_direct_sales: 0,
          indirect_achievement: 0,
          indirect_sales: 0,
          percent_indirect_sales: 0,
          total_sales: 0,
          total_achievement: 0,
          percent_total_sales: 0
        },
        total: {
          direct_achievement: 0,
          direct_sales: 0,
          percent_direct_sales: 0,
          indirect_achievement: 0,
          indirect_sales: 0,
          percent_indirect_sales: 0,
          total_sales: 0,
          total_achievement: 0,
          percent_total_sales: 0
        }
      },
      isLoader: false,
      isLoaderDD: false,
      isLoaderCC: false,
      ActiveText: "",
      zoneName: "",
      latestYear:
        new Date().getMonth() > 3
          ? new Date().getFullYear()
          : new Date().getFullYear() - 1,
    };
    this.reflocation = React.createRef();
    this.YTDFilter = React.createRef();
  }

  componentDidMount = () => {
    // this.getOffTakeSalesEntry("");
    // this.getDirectIndirectData("");
    // this.getFleetStatusCount("");
    this.getPopupLink();
    askForPermissioToReceiveNotifications();
    this.getFleetManagerOfftakeVerificationCount();
    if (this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE) {
      this.setState({
        type: "zone",
      });
    }

    setTimeout(() => {
      if (this.state.userDetail.type === "zonal_fleet_manager") {
        if (this.state.userDetail.zone == "sz1") {
          this.setState({ zoneName: "South 1" });
        } else if (this.state.userDetail.zone == "sz2") {
          this.setState({ zoneName: "South 2" });
        } else if (this.state.userDetail.zone == "ez") {
          this.setState({ zoneName: "East" });
        } else if (this.state.userDetail.zone === "nz") {
          this.setState({ zoneName: "North" });
        } else if (this.state.userDetail.zone === "wz") {
          this.setState({ zoneName: "West" });
        }
      }
    }, 500);
  };

  getSalesTargetAchivemet = () => {
    // this.setState({ isLoader: true });
    let controls =
      this.YTDFilter.current && this.YTDFilter.current.state.controls;
    // if (StorageService.getUserDetail().type !== Roles.FLEET_MANAGER_ROLE) {
    //   return;
    // }

    let filter = {
      type:
        this.state.userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE
          ? this.reflocation.current && this.reflocation.current.state.type
            ? this.reflocation.current.state.type
            : null
          : "zone",
      y: controls.year.value ? controls.year.value : this.state.latestYear,
      m: controls.month.value ? controls.month.value : null,
      q: controls.quarter.value ? controls.quarter.value : null,
      ref:
        this.state.userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE
          ? this.reflocation.current && this.reflocation.current.state.ref
            ? this.reflocation.current.state.ref
            : null
          : this.state.userDetail.zone,
      u:
        this.state.userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE
          ? this.reflocation.current &&
            this.reflocation.current.state.zoneData &&
            this.reflocation.current.state.zoneData.uuid
            ? this.reflocation.current.state.zoneData.uuid
            : null
          : this.state.userDetail.uuid,
    };

    this.setState({
      isLoader: true
    })
    DashboardService.getSalesTargetAchivemet(filter)
      .then(res => {
        let { sales_achievement } = this.state;
        sales_achievement = res.data.data;
        this.setState(prevState => {
          return {
            ...prevState,
            sales_achievement,
            isLoader: false
          };
        });
      })
      .catch(e => {
        this.setState({ isLoader: false });
      });
  }

  getOffTakeSalesEntry = (filterValue) => {
    let controls = this.YTDFilter.current.state.controls;

    let filter = {
      type:
        this.state.userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE
          ? this.reflocation.current && this.reflocation.current.state.type
            ? this.reflocation.current.state.type
            : null
          : "zone",
      y: controls.year.value ? controls.year.value : this.state.latestYear,
      m: controls.month.value ? controls.month.value : null,
      q: controls.quarter.value ? controls.quarter.value : null,
      ref:
        this.state.userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE
          ? this.reflocation.current && this.reflocation.current.state.ref
            ? this.reflocation.current.state.ref
            : null
          : this.state.userDetail.zone,
      u:
        this.state.userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE
          ? this.reflocation.current &&
            this.reflocation.current.state.zoneData &&
            this.reflocation.current.state.zoneData.uuid
            ? this.reflocation.current.state.zoneData.uuid
            : null
          : this.state.userDetail.uuid,
    };

    if (this.reflocation.current && this.reflocation.current.state.isAllIndia) {
      this.setState({
        type: true,
      });
      delete filter.u;
    } else {
      this.setState({
        type: false,
      });
    }
    // this.setState({ isLoader: false });

    HODashboardService.getOffTakeSalesEntry(filter)
      .then((res) => {
        this.setState({ isLoader: false });
        res.data.data.counts[res.data.data.counts.length] =
          res.data.data.counts[0];
        res.data.data.counts.splice(0, 1);
        this.setState({
          tableData: res.data.data.counts,
          total_tyres: res.data.data.total_tyres,
        });
      })
      .catch((err) => {
        this.setState({
          tableData: [],
          // isLoader: false,
        });
        console.log("err", err);
      });
    if (this.state.userDetail.type === "zonal_fleet_manager") {
      if (this.state.userDetail.zone == "sz1") {
        this.setState({ zoneName: "South 1" });
      } else if (this.state.userDetail.zone == "sz2") {
        this.setState({ zoneName: "South 2" });
      } else if (this.state.userDetail.zone == "ez") {
        this.setState({ zoneName: "East" });
      } else if (this.state.userDetail.zone === "nz") {
        this.setState({ zoneName: "North" });
      } else if (this.state.userDetail.zone === "wz") {
        this.setState({ zoneName: "West" });
      }
    }
    this.getSalesTargetAchivemet();
  };

  getDirectIndirectData = (filterValue) => {
    let controls = this.YTDFilter.current.state.controls;
    let filter = {
      y: controls.year.value ? controls.year.value : this.state.latestYear,
      m: controls.month.value ? controls.month.value : null,
      q: controls.quarter.value ? controls.quarter.value : null,
      u:
        this.reflocation.current &&
          this.reflocation.current.state &&
          this.reflocation.current.state.zoneData &&
          this.reflocation.current.state.zoneData.uuid
          ? this.reflocation.current.state.zoneData.uuid
          : null,
    };

    if (this.reflocation.current && this.reflocation.current.state.isAllIndia) {
      this.setState({
        type: true,
      });
      delete filter.u;
    } else {
      this.setState({
        type: false,
      });
    }
    this.setState({ isLoader: true });
    HODashboardService.getDirectIndirectData(filter)
      .then((res) => {
        this.setState({ isLoader: false });
        if (res.data.data.data[0].fleet_name === "Total") {
          res.data.data.data[res.data.data.data.length] = res.data.data.data[0];
          res.data.data.data.splice(0, 1);
        }
        this.setState({
          DirectIndirecttableData: res.data.data.data,
          DirectIndirect_total_tyres: res.data.data.total,
          isLoader: false,
        });
      })
      .catch((err) => {
        this.setState({
          isLoader: false,
          DirectIndirecttableData: [],
        });
        console.log("err", err);
      });
  };

  getFleetStatusCount = (filterValue) => {
    let controls = this.YTDFilter.current.state.controls;
    let filter = {
      y: controls.year.value ? controls.year.value : this.state.latestYear,
      m: controls.month.value ? controls.month.value : null,
      q: controls.quarter.value ? controls.quarter.value : null,
      u:
        this.reflocation.current &&
          this.reflocation.current.state &&
          this.reflocation.current.state.zoneData &&
          this.reflocation.current.state.zoneData.uuid
          ? this.reflocation.current.state.zoneData.uuid
          : null,
    };

    if (this.reflocation.current && this.reflocation.current.state.isAllIndia) {
      this.setState({
        type: true,
      });
      delete filter.u;
    } else {
      this.setState({
        type: false,
      });
    }

    this.setState({ isLoader: true });

    HODashboardService.getFleetStatusCount(filter)
      .then((res) => {
        this.setState({ isLoader: false });
        if (res.data.data.data[0].fleet_name === "Total") {
          res.data.data.data[res.data.data.data.length] = res.data.data.data[0];
          res.data.data.data.splice(0, 1);
        }
        this.setState({
          fleetStatusCountData: res.data.data.data,
          fleetStatusCountData_total_tyres: res.data.data.total,
          isLoaderCC: false,
        });
      })
      .catch((err) => {
        this.setState({
          isLoaderCC: false,
          fleetStatusCountData: [],
        });
        console.log("err", err);
      });
  };

  rounoffValues = (value) => {
    if (value) {
      let val = value.toString().split(".");
      if (val[1]) {
        let val2 = val[1].toString().split("");
        if (val2[0] >= 5) {
          value = Math.ceil(value);
        } else {
          value = Math.floor(value);
        }
      }
      return value;
    }
    return value;
  };

  updateZone = () => {
    this.setState();
  };

  Capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  downloadFleetStatusReport = (e, fleet, countType) => {
    const timeout = 60 * 2 * 1000;
    e.preventDefault();
    let controls = this.YTDFilter.current.state.controls;
    let filter = {};
    if (countType === "header_total") {
      filter = {
        y: controls.year.value ? controls.year.value : this.state.latestYear,
        m: controls.month.value ? controls.month.value : null,
        q: controls.quarter.value ? controls.quarter.value : null,
      };
    } else {
      filter = {
        y: controls.year.value ? controls.year.value : this.state.latestYear,
        m: controls.month.value ? controls.month.value : null,
        q: controls.quarter.value ? controls.quarter.value : null,
        u:
          this.reflocation.current &&
            this.reflocation.current.state &&
            this.reflocation.current.state.zoneData &&
            this.reflocation.current.state.zoneData.uuid &&
            !fleet.uuid
            ? this.reflocation.current.state.zoneData.uuid
            : fleet.uuid
              ? fleet.uuid
              : null,
        type: countType ? countType : "",
      };
    }
    this.setState({ isLoader: true });
    HODashboardService.downloadFleetStatusReport(filter, timeout)
      .then((res) => {
        this.setState({ isLoader: false });
        if (res.data && res.data.data && res.data.data.file) {
          downlodFile(res.data.data.file);
        }
        this.setState({ isLoader: false });
      })
      .catch((err) => {
        this.setState({
          isLoader: false,
        });
        console.log("err", err);
      });
  };

  downloadSalesReport = (e, fleet, countType) => {
    const timeout = 60 * 2 * 1000;
    e.preventDefault();
    let controls = this.YTDFilter.current.state.controls;
    let filter = {};
    if (countType === "header_total") {
      filter = {
        y: controls.year.value ? controls.year.value : this.state.latestYear,
        m: controls.month.value ? controls.month.value : null,
        q: controls.quarter.value ? controls.quarter.value : null,
        u:
          this.reflocation.current &&
            this.reflocation.current.state &&
            this.reflocation.current.state.zoneData &&
            this.reflocation.current.state.zoneData.uuid &&
            !fleet.uuid
            ? this.reflocation.current.state.zoneData.uuid
            : fleet.uuid
              ? fleet.uuid
              : null,
      };
    } else {
      filter = {
        y: controls.year.value ? controls.year.value : this.state.latestYear,
        m: controls.month.value ? controls.month.value : null,
        q: controls.quarter.value ? controls.quarter.value : null,
        u:
          this.reflocation.current &&
            this.reflocation.current.state &&
            this.reflocation.current.state.zoneData &&
            this.reflocation.current.state.zoneData.uuid &&
            !fleet.uuid
            ? this.reflocation.current.state.zoneData.uuid
            : fleet.uuid
              ? fleet.uuid
              : null,
        type: countType ? countType : "",
      };
    }
    this.setState({ isLoader: true });
    HODashboardService.downloadSalesReport(filter, timeout)
      .then((res) => {
        this.setState({ isLoader: false });
        if (res.data && res.data.data && res.data.data.file) {
          downlodFile(res.data.data.file);
        }
        this.setState({ isLoader: false });
      })
      .catch((err) => {
        this.setState({
          isLoader: false,
        });
        console.log("err", err);
      });
  };


  downloadVerifiedSales = (e, fleet) => {
    e.preventDefault();
    let controls = this.YTDFilter.current.state.controls;
    let filter = {};

    filter = {
      y: controls.year.value ? controls.year.value : this.state.latestYear,
      m: controls.month.value ? controls.month.value : null,
      q: controls.quarter.value ? controls.quarter.value : null,
      u:
        this.reflocation.current &&
          this.reflocation.current.state &&
          this.reflocation.current.state.zoneData &&
          this.reflocation.current.state.zoneData.uuid &&
          !fleet.uuid
          ? this.reflocation.current.state.zoneData.uuid
          : fleet.uuid
            ? fleet.uuid
            : null,
    };

    this.setState({ isLoader: true });
    HODashboardService.downloadVerifiedSales(filter)
      .then((res) => {
        this.setState({ isLoader: false });
        if (res.data && res.data.data && res.data.data.file) {
          downlodFile(res.data.data.file);
        }
        this.setState({ isLoader: false });
      })
      .catch((err) => {
        this.setState({
          // isLoader: false,
        });
        console.log("err", err);
      });
  };
  onPendingInvoiceClick = () => {
    this.props.history.push("/invoiceVerification?PD=true");
  };

  getFleetManagerOfftakeVerificationCount = async () => {
    let { fmOfftakeEntriesCount } = this.state;

    try {
      const { data } = await FleetManagerService.getOfftakeEntriesCount();
      if (data) {
        if (this.state.memberRole === Roles.FLEET_MANAGER_ROLE) {
          fmOfftakeEntriesCount =
            _.filter(data.data, (item) => {
              return (item.status || "").toLowerCase() === "pending";
            })[0] || {};
        } else {
          fmOfftakeEntriesCount =
            _.filter(data.data, (item) => {
              return (item.status || "").toLowerCase() === "pending_zfm";
            })[0] || {};
        }
      }
      this.setState({ fmOfftakeEntriesCount });
    } catch (error) {
      console.log(error);
    }
  };

  getPopupLink = () => {
    let controls = this.YTDFilter.current.state.controls;
    let year = controls.year.value ? controls.year.value : this.state.latestYear;
    SpeacialEngagementService.getPopupLink(year)
      .then((data) => {
        if (data.data && data.data.data.link) {
          this.setState({ isSpecialEngagementModalOpen: true });
        }
      })
      .catch((e) => { });
  };

  closeSpecialEngagementModal = () => {
    this.setState({ isSpecialEngagementModalOpen: false });
  };

  render() {
    let {
      tableData,
      total_tyres,
      // type,
      memberRole,
      // memberId,
      fmOfftakeEntriesCount,
      DirectIndirecttableData,
      DirectIndirect_total_tyres,
      fleetStatusCountData,
      fleetStatusCountData_total_tyres,
      sales_achievement,
      isSpecialEngagementModalOpen
    } = this.state;



    return (
      <div id="ho-dashboard">
        {this.state.isLoader && <CustomSpinner />}
        {
          isSpecialEngagementModalOpen && (
            <SpeacialEngagement
              show={isSpecialEngagementModalOpen}
              // popupDetail={popupDetail}
              closeModal={this.closeSpecialEngagementModal}
            />
          )
        }
        <Row>
          <Col
            className="Points-Report"
            md={
              this.state.userDetail.type === Roles.HEAD_OFFICE_BAADSHAH_ROLE ? "8" : "12"
            }
            xs="12"
          >
            Dashboard
          </Col>
          {this.state.userDetail.type === Roles.HEAD_OFFICE_BAADSHAH_ROLE && (
            <Col md="4" xs="12" style={{ paddingLeft: "60px" }}>
              <AutoSuggestionDealer
                {...this.props}
                getSelectedFleetData={false}
                HOD={true}
                zone={this.state.zone}
                controls={this && this.YTDFilter && this.YTDFilter.current && this.YTDFilter.current.state && this.YTDFilter.current.state.controls && this.YTDFilter.current.state.controls}
              />
            </Col>
          )}
        </Row>

        {memberRole === Roles.ZONAL_FLEET_MANAGER_ROLE &&
          fmOfftakeEntriesCount.count > 0 && (
            <div
              className="page-title  report-gradient-title"
              style={{ marginTop: "-2px", marginBottom: "15px" }}
            >
              <Row
                onClick={this.onPendingInvoiceClick}
                style={{ cursor: "pointer" }}
              >
                <Col xs="8" className="report-gradient-small-text">
                  You have {fmOfftakeEntriesCount.count} invoices pending for
                  verification
                </Col>
                <Col
                  xs="4"
                  className="text-align-right report-gradient-big-text"
                >
                  Start Verification Now
                </Col>
              </Row>
              {/* Complete your business profile and earn 500 points */}
            </div>
          )}

        <Row>
          <Col
            className="d-flex-row"
            style={{ justifyContent: "space-between" }}
            md={
              this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE ? "8" : "12"
            }
            xs="12"
          >
            <div className="Showing-results-of">
              Showing results of{" "}
              {this.state.userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE
                ? this.reflocation.current &&
                  this.reflocation.current.state.zoneName
                  ? this.reflocation.current.state.zoneName + " zone for "
                  : "All India for "
                : ""}{" "}
              {this.YTDFilter.current &&
                this.YTDFilter.current.state.monthName &&
                this.YTDFilter.current.state.monthName + " month, "}{" "}
              {this.YTDFilter.current &&
                this.YTDFilter.current.state.controls &&
                this.YTDFilter.current.state.controls.quarter &&
                this.YTDFilter.current.state.controls.quarter.value &&
                "Q" +
                this.YTDFilter.current.state.controls.quarter.value +
                ", "}{" "}
              {this.YTDFilter.current &&
                this.YTDFilter.current.state.controls &&
                this.YTDFilter.current.state.controls.month &&
                !this.YTDFilter.current.state.controls.month.value &&
                this.YTDFilter.current &&
                this.YTDFilter.current.state.controls &&
                this.YTDFilter.current.state.controls.quarter &&
                !this.YTDFilter.current.state.controls.quarter.value &&
                this.state.userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE &&
                "year"}{" "}
              {this.YTDFilter.current &&
                this.YTDFilter.current.state.year_name_value[0] &&
                this.YTDFilter.current.state.year_name_value[0].name}
            </div>

            <div
              style={{
                display: "flex",
                marginRight:
                  this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE
                    ? "-55px"
                    : "0px",
              }}
            >
              {this.state.userDetail.type !== Roles.ZONAL_FLEET_MANAGER_ROLE && (
                <LocationWiseFilter
                  getOffTakeSalesEntry={(filterValue) =>
                    this.getOffTakeSalesEntry(filterValue)
                  }
                  getFleetStatusCount={this.getFleetStatusCount}
                  getDirectIndirectData={this.getDirectIndirectData}
                  zone={
                    this.YTDFilter.current &&
                    this.YTDFilter.current.state.allZone
                  }
                  ref={this.reflocation}
                />
              )}
              &nbsp;&nbsp;&nbsp;
              <YTDFilter
                updateZone={this.updateZone}
                year2020={false}
                getFleetStatusCount={this.getFleetStatusCount}
                getDirectIndirectData={this.getDirectIndirectData}
                getOffTakeSalesEntry={(filterValue) =>
                  this.getOffTakeSalesEntry(filterValue)
                }
                ref={this.YTDFilter}
              />
            </div>
          </Col>
          {this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE && (
            <Col md="4" xs="12" style={{ paddingLeft: "50px" }}>
              <AutoSuggestionDealer
                {...this.props}
                getSelectedFleetData={false}
                HOD={true}
                zone={this.state.zone}
              />
            </Col>
          )}{" "}
        </Row>
        <br />

        {/* <Card style={{ marginTop: "-10px" }}>
          <CardBody className="pt-0 pb-0 pr-0">
            <Row style={{ marginRight: "-16px", marginLeft: "-16px" }}>
              <table
                className="border-0 ml-n1 table-responsive"
                style={{ width: "99%" }}
              >
                <thead className="thead-count">
                  <th>
                    TBR
                  </th>
                </thead>
              </table>
            </Row>
          </CardBody>
        </Card> */}
        <Card style={{ marginTop: "-10px" }}>
          <CardBody className="pt-0 pb-0 pr-0">
            <Row style={{ marginRight: "-16px", marginLeft: "-16px" }}>

              <table
                className="border-0 ml-n1 table-responsive"
                style={{ width: "99%" }}
              >
                <thead className="thead-count">
                  <tr>
                    <td
                      colspan="100%"
                      className="p-3 top-border-radius-5"
                      style={{ textAlign: "left" }}
                    >
                      <span className="Total-Members-Fleet">
                        Sales Target vs Achievement</span>
                    </td>
                  </tr>
                </thead>
                <thead className="tbl-data">
                  <tr style={{ backgroundColor: "#f1f1f1" }}>
                    <td className="w-10-percentage text-center borderBottom-ced4da">
                      Sales
                    </td>
                    <td
                      colSpan="2"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                      style={{ borderLeft: "1px solid #ced4da" }}
                    >
                      TBR
                    </td>
                    <td
                      colSpan="2"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                    >
                      TBB
                    </td>
                    <td
                      colSpan="2"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                    >
                      Total
                    </td>
                  </tr>
                  <tr className="thead-sub">
                    <td className="borderRight-ced4da borderBottom-ced4da"></td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Achievement / Target
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      % Achievement
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Achievement / Target
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      % Achievement
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      % Achievement
                    </td>
                  </tr>
                </thead>
                <tbody className="tbody-count tbl-data">
                  <tr>
                    <td
                      className="borderRight-ced4da borderBottom-ced4da"
                      style={{ fontWeight: 'bold' }}
                    >
                      Direct
                    </td>
                    <td className='borderRight-ced4da font-weight-normal  borderBottom-ced4da'>
                      {sales_achievement.tbr.direct_achievement + " "}/{" " + sales_achievement.tbr.direct_sales}
                    </td>
                    <td
                      className="borderRight-ced4da font-weight-normal  borderBottom-ced4da">
                      {sales_achievement.tbr.percent_direct_sales ? this.rounoffValues(sales_achievement.tbr.percent_direct_sales) + '%' : 0}
                    </td>
                    <td
                      className="borderRight-ced4da font-weight-normal  borderBottom-ced4da">
                      {sales_achievement.tbb.direct_achievement + " "}/{" " + sales_achievement.tbb.direct_sales}
                    </td>
                    <td
                      className={"borderRight-ced4da font-weight-normal  borderBottom-ced4da"}>
                      {sales_achievement.tbb.percent_direct_sales ? this.rounoffValues(sales_achievement.tbb.percent_direct_sales) + '%' : 0}
                    </td>
                    <td
                      className="borderRight-ced4da font-weight-normal  borderBottom-ced4da">
                      {sales_achievement.total.direct_achievement + " "}/{" " + sales_achievement.total.direct_sales}
                    </td>
                    <td
                      className={"borderRight-ced4da font-weight-normal  borderBottom-ced4da"}>
                      {sales_achievement.total.percent_direct_sales ? this.rounoffValues(sales_achievement.total.percent_direct_sales) + '%' : 0}
                    </td>
                  </tr>
                  {/* <tr>
                    <td
                      className="borderRight-ced4da borderBottom-ced4da"
                      style={{ fontWeight: 'bold' }}
                    >
                      Indirect
                      </td>
                    <td className='borderRight-ced4da font-weight-normal  borderBottom-ced4da'>
                      {sales_achievement.tbr.indirect_achievement + " "}/{" " + sales_achievement.tbr.indirect_sales}
                    </td>
                    <td
                      className="borderRight-ced4da font-weight-normal  borderBottom-ced4da">
                      {sales_achievement.tbr.percent_indirect_sales ? this.rounoffValues(sales_achievement.tbr.percent_indirect_sales) + '%' : 0}
                    </td>
                    <td
                      className="borderRight-ced4da font-weight-normal  borderBottom-ced4da">
                      {sales_achievement.tbb.indirect_achievement + " "}/{" " + sales_achievement.tbb.indirect_sales}
                    </td>
                    <td
                      className={"borderRight-ced4da font-weight-normal  borderBottom-ced4da"}>
                      {sales_achievement.tbb.percent_indirect_sales ? this.rounoffValues(sales_achievement.tbb.percent_indirect_sales) + '%' : 0}
                    </td>
                    <td
                      className="borderRight-ced4da font-weight-normal  borderBottom-ced4da">
                      {sales_achievement.total.indirect_achievement + " "}/{" " + sales_achievement.total.indirect_sales}
                    </td>
                    <td
                      className={"borderRight-ced4da font-weight-normal  borderBottom-ced4da"}>
                      {sales_achievement.total.percent_indirect_sales ? this.rounoffValues(sales_achievement.total.percent_indirect_sales) + '%' : 0}
                    </td>
                  </tr> */}

                  <tr>
                    <td className="borderRight-ced4da borderBottom-ced4da"
                      style={{ backgroundColor: "#faf2d2", fontWeight: "bold" }}
                    >
                      Total
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da"
                      style={{ backgroundColor: "#faf2d2", fontWeight: "bold" }}>
                      {sales_achievement.tbr.total_achievement + " "}/{" " + sales_achievement.tbr.total_sales}
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da"
                      style={{ backgroundColor: "#faf2d2", fontWeight: "bold" }}>
                      {sales_achievement.tbr.percent_total_sales ? this.rounoffValues(sales_achievement.tbr.percent_total_sales) + '%' : 0}
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da"
                      style={{ backgroundColor: "#faf2d2", fontWeight: "bold" }}>
                      {sales_achievement.tbb.total_achievement + " "}/{" " + sales_achievement.tbb.total_sales}
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da"
                      style={{ backgroundColor: "#faf2d2", fontWeight: "bold" }}>
                      {sales_achievement.tbb.percent_total_sales ? this.rounoffValues(sales_achievement.tbb.percent_total_sales) + '%' : 0}
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da"
                      style={{ backgroundColor: "#faf2d2", fontWeight: "bold" }}>
                      {sales_achievement.total.total_achievement + " "}/{" " + sales_achievement.total.total_sales}
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da"
                      style={{ backgroundColor: "#faf2d2", fontWeight: "bold" }}>
                      {sales_achievement.total.percent_total_sales ? this.rounoffValues(sales_achievement.total.percent_total_sales) + '%' : 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Row>
          </CardBody>
        </Card>

        <Card style={{ marginTop: "15px" }}>
          <CardBody className="pt-0 pb-0 pr-0">
            <Row style={{ marginRight: "-16px", marginLeft: "-16px" }}>

              <table
                className="border-0 ml-n1 table-responsive"
                style={{ width: "99%" }}
              >
                <thead className="thead-count">
                  <tr>
                    <td
                      colspan="100%"
                      className="p-3 top-border-radius-5"
                      style={{ textAlign: "left" }}
                    >
                      <span className="Total-Members-Fleet">
                        Total Members (Fleets) of JK Baadshah Programme -&nbsp;
                        <span
                          className={"hyperLink"}
                          onClick={(e) =>
                            this.downloadFleetStatusReport(
                              e,
                              fleetStatusCountData_total_tyres,
                              "header_total"
                            )
                          }
                        >
                          {formatNumber(fleetStatusCountData_total_tyres)}
                        </span>
                      </span>
                      <span className="offtake-entry-text">
                        Note:{" "}

                        {this.YTDFilter.current &&
                          this.YTDFilter.current.state.ActiveText}
                      </span>
                    </td>
                  </tr>
                </thead>
                <thead className="tbl-data">
                  <tr style={{ backgroundColor: "#f1f1f1" }}>
                    <td className="w-10-percentage text-center borderBottom-ced4da">
                      {(this.reflocation.current &&
                        this.reflocation.current.state.zoneName) ||
                        this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE
                        ? "FM Name & Location"
                        : "Zone"}
                    </td>
                    {this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE && <td className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da">
                      Last Login
                    </td>}
                    <td
                      colSpan="2"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                      style={{ borderLeft: "1px solid #ced4da" }}
                    >
                      Direct
                    </td>
                    {/* <td
                      colSpan="2"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                    >
                      Indirect
                    </td> */}
                    {/* hide changes 8aug23 */}
                    {/* <td
                      colSpan="2"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                    >
                      Mobility
                    </td> */}
                    <td
                      colSpan="2"
                      className="w-20-percentage text-center borderBottom-ced4da"
                    >
                      Total Fleets
                    </td>
                  </tr>
                  <tr className="thead-sub">
                    <td className="borderRight-ced4da borderBottom-ced4da"></td>
                    {this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE && <td className="borderRight-ced4da borderBottom-ced4da"></td>}
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Active
                    </td>
                    {/* <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td> */}
                    {/* <td className="borderRight-ced4da borderBottom-ced4da">
                      Active
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td> */}
                    {/* <td className="borderRight-ced4da borderBottom-ced4da">
                      Active
                    </td> */}
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td>
                    <td className="borderBottom-ced4da"> Active</td>
                  </tr>
                </thead>
                <tbody className="tbody-count tbl-data">
                  {fleetStatusCountData.map((item) => (
                    <tr>
                      <td
                        className="borderRight-ced4da borderBottom-ced4da"
                        style={{
                          backgroundColor:
                            item && item.fleet_name === "Total" ? "#faf2d2" : "",
                          fontWeight:
                            item && item.fleet_name === "Total" ? "bold " : "",
                        }}
                      >
                        {item && item.fleet_name}
                        <div style={{ color: "#545a60", fontWeight: "normal" }}>
                          {" "}
                          {item && item.area
                            ? this.Capitalize(item && item.area)
                            : ""}
                          {item && item.region
                            ? " (" + this.Capitalize(item && item.region) + ")"
                            : ""}
                        </div>
                      </td>
                      {this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE && <td
                        className={
                          item && item.fleet_name === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.fleet_name === "Total" ? "#faf2d2" : "",
                          fontWeight:
                            item && item.fleet_name === "Total" ? "bold" : "",
                        }}>
                        {item.last_login && <Moment format="DD MMM'YY, h:mm a">
                          {item && item.last_login}
                        </Moment>}
                        { }
                      </td>}
                      <td
                        className={
                          item && item.fleet_name === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.fleet_name === "Total" ? "#faf2d2" : "",
                          fontWeight:
                            item && item.fleet_name === "Total" ? "bold" : "",
                        }}
                      >
                        <span
                          className={"hyperLink"}
                          onClick={(e) =>
                            this.downloadFleetStatusReport(e, item, "direct")
                          }
                        >
                          {" "}
                          {item && item.direct_total_count}
                        </span>
                      </td>
                      <td
                        className={
                          item && item.fleet_name === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.fleet_name === "Total" ? "#faf2d2" : "",
                          fontWeight: item.fleet_name === "Total" ? "bold " : "",
                        }}
                      >
                        {item && item.direct_active_count}
                      </td>
                      {/* <td
                        className={
                          item && item.fleet_name == "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.fleet_name == "Total" ? "#faf2d2" : "",
                          fontWeight:
                            item && item.fleet_name == "Total" ? "bold " : "",
                        }}
                      >
                        <span
                          className={"hyperLink"}
                          onClick={(e) =>
                            this.downloadFleetStatusReport(e, item, "indirect")
                          }
                        >
                          {item && item.indirect_total_count}
                        </span>
                      </td> */}
                      {/* <td
                        className={
                          item && item.fleet_name == "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.fleet_name == "Total" ? "#faf2d2" : "",
                          fontWeight:
                            item && item.fleet_name == "Total" ? "bold " : "",
                        }}
                      >
                        {item && item.indirect_active_count}
                      </td> */}
                      {/* <td
                        className={
                          item && item.fleet_name === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.fleet_name === "Total" ? "#faf2d2" : "",
                          fontWeight:
                            item && item.fleet_name === "Total" ? "bold " : "",
                        }}
                      >
                        {item && item.mobility_total_count}
                      </td> */}
                      {/* <td
                        className={
                          item && item.fleet_name === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.fleet_name === "Total" ? "#faf2d2" : "",
                          fontWeight:
                            item && item.fleet_name === "Total" ? "bold " : "",
                        }}
                      >
                        {item && item.mobility_active_count}
                      </td> */}
                      <td
                        className={
                          item && item.fleet_name === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.fleet_name === "Total" ? "#faf2d2" : "",
                          fontWeight:
                            item && item.fleet_name === "Total" ? "bold " : "",
                        }}
                      >
                        {/* <span
                          className={
                            item && item.fleet_name !== "Total" && "hyperLink"
                          }
                          onClick={e =>
                            item &&
                            item.fleet_name !== "Total" &&
                            this.downloadFleetStatusReport(e, item, "")
                          }
                        > */}
                        {item && item.total_count}
                        {/* </span> */}
                      </td>
                      <td
                        className={
                          item && item.fleet_name === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.fleet_name === "Total" ? "#faf2d2" : "",
                          fontWeight:
                            item && item.fleet_name === "Total" ? "bold " : "",
                        }}
                      >
                        {item && item.total_active_count}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Row>
          </CardBody>
        </Card>

        <Card style={{ marginTop: "15px" }}>
          <CardBody className="pt-0 pb-0 pr-0">
            <Row style={{ marginRight: "-16px", marginLeft: "-16px" }}>
              {/* <Col xl="12" xs="12" md="12" className="card-header-count">
                <span>Total Members(Fleets) of JK Baadshah Programme - 1,750</span>
              </Col> */}
              <table
                className="border-0 ml-n1 table-responsive"
                style={{ width: "99%" }}
              >
                <thead className="thead-count">
                  <tr>
                    <td
                      colspan="100%"
                      className="p-3 top-border-radius-5"
                      style={{ textAlign: "left" }}
                    >
                      <span className="Total-Members-Fleet">
                        Offtake As Per Sales Entries -{" "}
                        <span
                          className={"hyperLink"}
                          onClick={(e) =>
                            this.downloadSalesReport(
                              e,
                              total_tyres,
                              "header_total"
                            )
                          }
                        >
                          {formatNumber(this.rounoffValues(total_tyres))}
                        </span>{" "}
                        Tyres
                      </span>
                      <span className="offtake-entry-text">
                        Note: Offtake entry shows the average per month data.
                      </span>
                    </td>
                  </tr>
                </thead>
                <thead className="tbl-data">
                  <tr style={{ backgroundColor: "#f1f1f1" }}>
                    <td className="w-10-percentage text-center borderBottom-ced4da">
                      {(this.reflocation.current &&
                        this.reflocation.current.state.zoneName) ||
                        this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE
                        ? "FM Name & Location"
                        : "Zone"}
                    </td>
                    <td
                      colSpan="3"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                      style={{ borderLeft: "1px solid #ced4da" }}
                    >
                      Direct
                    </td>
                    {/* <td
                      colSpan="3"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                    >
                      Indirect
                    </td> */}
                    {/* hide changes 8aug23 */}
                    {/* <td
                      colSpan="3"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                    >
                      Mobility
                    </td> */}
                    <td
                      colSpan="3"
                      className="w-20-percentage text-center borderBottom-ced4da"
                    >
                      Total Offtake
                    </td>
                  </tr>
                  <tr className="thead-sub">
                    <td className="borderRight-ced4da borderBottom-ced4da"></td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      TBR
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      TBB
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td>
                    {/* <td className="borderRight-ced4da borderBottom-ced4da">
                      TBR
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      TBB
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td> */}
                    {/* <td className="borderRight-ced4da borderBottom-ced4da">
                      TBR
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      TBB
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td> */}
                    <td className="borderRight-ced4da borderBottom-ced4da ">
                      TBR
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      TBB
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td>
                  </tr>
                </thead>
                <tbody className="tbody-count tbl-data">
                  {tableData.map((item) => (
                    <tr>
                      <td
                        className="borderRight-ced4da borderBottom-ced4da"
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {item && item.title}
                        <div style={{ color: "#545a60", fontWeight: "normal" }}>
                          {" "}
                          {item && item.area_name
                            ? this.Capitalize(item.area_name)
                            : ""}
                          {item && item.region_name
                            ? " (" + this.Capitalize(item.region_name) + ")"
                            : ""}
                        </div>
                      </td>
                      <td
                        className={
                          item && item.title === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {this.rounoffValues(item.direct_tbr)}
                      </td>
                      <td
                        className={
                          item && item.title === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {" "}
                        {this.rounoffValues(item.direct_tbb)}
                      </td>
                      <td
                        className={
                          item && item.title === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {this.rounoffValues(item.total_direct)}
                      </td>
                      {/* <td
                        className={
                          item && item.title === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {this.rounoffValues(item.indirect_tbr)}
                      </td>
                      <td
                        className={
                          item && item.title === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {this.rounoffValues(item.indirect_tbb)}
                      </td>
                      <td
                        className={
                          item && item.title === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {this.rounoffValues(item.total_indirect)}
                      </td> */}
                      {/* <td
                        className={
                          item && item.title === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {this.rounoffValues(item.mobility_tbr)}
                      </td>
                      <td
                        className={
                          item && item.title === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {this.rounoffValues(item.mobility_tbb)}
                      </td>
                      <td
                        className={
                          item && item.title === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {this.rounoffValues(item.total_mobility)}
                      </td> */}
                      <td
                        className={
                          item && item.title === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {this.rounoffValues(item.total_tbr)}
                      </td>
                      <td
                        className={
                          item && item.title === "Total"
                            ? "borderRight-ced4da borderBottom-ced4da"
                            : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {" "}
                        {this.rounoffValues(item.total_tbb)}
                      </td>
                      <td
                        className={
                          item && item.title === "Total"
                            ? "borderBottom-ced4da"
                            : "font-weight-normal  borderBottom-ced4da"
                        }
                        style={{
                          backgroundColor:
                            item && item.title === "Total" ? "#faf2d2" : "",
                          fontWeight: item.title === "Total" ? "bold" : "",
                        }}
                      >
                        {this.rounoffValues(item.total)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Row>
          </CardBody>
        </Card>

        {/* hide changes 8aug23 */}
        {/* <Card style={{ marginTop: "15px" }}>
          <CardBody className="pt-0 pb-0 pr-0">
            <Row style={{ marginRight: "-16px", marginLeft: "-16px" }}> */}
        {/* <Col xl="12" xs="12" md="12" className="card-header-count">
                <span>Total Members(Fleets) of JK Baadshah Programme - 1,750</span>
              </Col> */}
        {/* <table
                className="border-0 ml-n1 table-responsive"
                style={{ width: "99%" }}
              >
                <thead className="thead-count">
                  <tr>
                    <td
                      colspan="100%"
                      className="p-3 top-border-radius-5"
                      style={{ textAlign: "left" }}
                    >
                      <span className="Total-Members-Fleet">
                        Verified Offtake (Based on SAP data and approved
                        Invoices) -{" "}

                        <span
                          className={"hyperLink"}
                          onClick={(e) =>
                            this.downloadVerifiedSales(
                              e,
                              DirectIndirect_total_tyres,
                            )
                          }
                        >
                          {formatNumber(
                            this.rounoffValues(DirectIndirect_total_tyres)
                          )}{" "}
                          Tyres
                        </span>
                      </span>
                      <span className="offtake-entry-text">
                        Note: Offtake entry shows the average per month data.
                      </span>
                    </td>
                  </tr>
                </thead>
                <thead className="tbl-data">
                  <tr style={{ backgroundColor: "#f1f1f1" }}>
                    <td className="w-10-percentage text-center borderBottom-ced4da">
                      {(this.reflocation.current &&
                        this.reflocation.current.state.zoneName) ||
                        this.state.userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE
                        ? "FM Name & Location"
                        : "Zone"}
                    </td>
                    <td
                      colSpan="3"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                      style={{ borderLeft: "1px solid #ced4da" }}
                    >
                      Direct
                    </td> */}
        {/* <td
                      colSpan="3"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                    >
                      Indirect
                    </td> */}
        {/* <td
                      colSpan="3"
                      className="w-20-percentage text-center borderBottom-ced4da borderRight-ced4da"
                    >
                      Mobility
                    </td>
                    <td
                      colSpan="3"
                      className="w-20-percentage text-center borderBottom-ced4da"
                    >
                      Total Verified Offtake
                    </td>
                  </tr>
                  <tr className="thead-sub">
                    <td className="borderRight-ced4da borderBottom-ced4da"></td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      TBR
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      TBB
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td> */}
        {/* <td className="borderRight-ced4da borderBottom-ced4da">
                      TBR
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      TBB
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td> */}
        {/* <td className="borderRight-ced4da borderBottom-ced4da">
                      TBR
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      TBB
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      TBR
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      TBB
                    </td>
                    <td className="borderRight-ced4da borderBottom-ced4da">
                      Total
                    </td>
                  </tr>
                </thead>
                <tbody className="tbody-count tbl-data">
                  {DirectIndirecttableData &&
                    DirectIndirecttableData.map((item) => (
                      <tr>
                        <td
                          className="borderRight-ced4da borderBottom-ced4da"
                          style={{
                            backgroundColor:
                              item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {item && item.fleet_name}
                          <div
                            style={{ color: "#545a60", fontWeight: "normal" }}
                          >
                            {" "}
                            {item && item.area
                              ? this.Capitalize(item.area)
                              : ""}
                            {item && item.region
                              ? " (" + this.Capitalize(item.region) + ")"
                              : ""}
                          </div>
                        </td>
                        <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderRight-ced4da borderBottom-ced4da"
                              : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {this.rounoffValues(item && item.direct_tbr)}
                        </td>
                        <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderRight-ced4da borderBottom-ced4da"
                              : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {" "}
                          {this.rounoffValues(item && item.direct_tbb)}
                        </td>
                        <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderRight-ced4da borderBottom-ced4da"
                              : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {this.rounoffValues(item && item.direct_total)}
                        </td> */}
        {/* <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderRight-ced4da borderBottom-ced4da"
                              : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {this.rounoffValues(item && item.indirect_tbr)}
                        </td>
                        <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderRight-ced4da borderBottom-ced4da"
                              : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {this.rounoffValues(item && item.indirect_tbb)}
                        </td>
                        <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderRight-ced4da borderBottom-ced4da"
                              : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {this.rounoffValues(item && item.indirect_total)}
                        </td> */}

        {/* <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderRight-ced4da borderBottom-ced4da"
                              : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {this.rounoffValues(item && item.mobility_tbr)}
                        </td>
                        <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderRight-ced4da borderBottom-ced4da"
                              : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {this.rounoffValues(item && item.mobility_tbb)}
                        </td>
                        <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderRight-ced4da borderBottom-ced4da"
                              : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {this.rounoffValues(item && item.mobility_total)}
                        </td>

                        <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderRight-ced4da borderBottom-ced4da"
                              : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {this.rounoffValues(item && item.total_tbr)}
                        </td>

                        <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderRight-ced4da borderBottom-ced4da"
                              : "borderRight-ced4da font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {" "}
                          {this.rounoffValues(item && item.total_tbb)}
                        </td>
                        <td
                          className={
                            item && item.fleet_name === "Total"
                              ? "borderBottom-ced4da"
                              : "font-weight-normal  borderBottom-ced4da"
                          }
                          style={{
                            backgroundColor:
                              item && item.fleet_name === "Total"
                                ? "#faf2d2"
                                : "",
                            fontWeight:
                              item && item.fleet_name === "Total" ? "bold" : "",
                          }}
                        >
                          {this.rounoffValues(item && item.total)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table> */}
        {/* </Row>
          </CardBody>
        </Card> */}
      </div>
    );
  }
}

export default withRouter(HoDashboard);
